import styled from 'styled-components'
import { colors } from '@monorepo/theme'

export {
  ModalButton,
  MultiSelectStyle,
  SelectStyle,
  DialogActions,
  DialogForm,
  ErrorMessage,
} from '../DealerForm/styles'

export const FieldError = styled.span`
  color: ${colors.red};
  font-family: PFDINText;
  font-size: 12px;
  margin-top: -16px;
`
